import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Button } from 'primereact/button';
import { useNavigate, useLocation } from 'react-router-dom';
import 'primeflex/primeflex.css';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import logo_nematool from '../assets/logo.png';
import Papa from 'papaparse';
import { AutoComplete } from 'primereact/autocomplete';
import { Widget, addResponseMessage, addUserMessage, renderCustomComponent, deleteMessages } from 'react-chat-widget';
import 'react-chat-widget/lib/styles.css';
import { Toast } from 'primereact/toast';
// import { ModalInstall } from './ModalInstall';
import * as XLSX from 'xlsx';
import { DataTable } from 'primereact/datatable';
import { Column }    from 'primereact/column';
import { inicializarTracking, registrarClick, registrarBusqueda, registrarDescarga, registrarFormulario, registrarPreguntaChat } from '../utils/tracking';

const X_API_FITOS_KEY = 'xK9mP2vL8nQ4wR7jT5bY3cF6hA1dG0sZ';

const Main = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [nombre, setNombre] = useState(location.state?.nombre || '');
  const [formulado, setFormulado] = useState(location.state?.formulado || '');
  const [numRegistro, setNumRegistro] = useState(location.state?.numRegistro || '');
  const [titular, setTitular] = useState(location.state?.titular || '');
  const [link, setLink] = useState('');
  const [data, setData] = useState([]);
  const [nombres, setNombres] = useState([]);
  const [formulados, setFormulados] = useState([]);
  const [numRegistros, setNumRegistros] = useState([]);
  const [titulares, setTitulares] = useState([]);
  const [links, setLinks] = useState([]);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [filteredNombres, setFilteredNombres] = useState([]);
  const [filteredFormulados, setFilteredFormulados] = useState([]);
  const [filteredNumRegistros, setFilteredNumRegistros] = useState([]);
  const [filteredTitulares, setFilteredTitulares] = useState([]);
  const [messageCount, setMessageCount] = useState(location.state?.messageCount || 0);
  const [chatHistory, setChatHistory] = useState([]);
  const toast = useRef(null);
  const autoCompleteNumRegistroRef = useRef(null);
  const autoCompleteNombreRef = useRef(null);
  const autoCompleteFormuladoRef = useRef(null);
  const autoCompleteTitularRef = useRef(null);
  const [threadId, setThreadId] = useState(null);
  // Responses API (reemplazo recomendado de Threads/Assistants): encadena turnos con previous_response_id
  const [previousResponseId, setPreviousResponseId] = useState(null);
  // Conversations API: estado de conversación sin reenviar historial ni encadenar responses manualmente
  const [conversationId, setConversationId] = useState(null);
  const [listening, setListening] = useState(false);
  const [animate, setAnimate] = useState(false);
  const recognitionRef = useRef(null);
  const [widgetIsOpen, setWidgetIsOpen] = useState(false);


  /*
  // Ajustar altura del contenedor de mensajes cuando el teclado está abierto
  useEffect(() => {
    // Solo en móviles
    if (window.innerWidth > 800) return;

    const adjustMessagesHeight = () => {
      const messagesContainer = document.querySelector('.rcw-messages-container');
      const microphoneDiv = document.querySelector('.div-microphone');
      if (!messagesContainer) return;

      // Usar Visual Viewport API si está disponible
      if (window.visualViewport) {
        const viewportHeight = window.visualViewport.height;
        const keyboardHeight = window.innerHeight - viewportHeight;
        
        // Si el teclado está abierto (diferencia > 150px)
        if (keyboardHeight > 150) {
          // Altura disponible = altura del viewport menos header y sender
          const headerHeight = document.querySelector('.rcw-header')?.offsetHeight || 60;
          const senderHeight = document.querySelector('.rcw-sender')?.offsetHeight || 60;
          const availableHeight = viewportHeight - headerHeight - senderHeight;
          
          messagesContainer.style.height = `${availableHeight}px`;
          messagesContainer.style.maxHeight = `${availableHeight}px`;
          
          // Ajustar posición del micrófono: bottom original (22px) + altura del teclado
          if (microphoneDiv) {
            const originalBottom = 22; // Valor original en móviles
            microphoneDiv.style.bottom = `${originalBottom + keyboardHeight}px`;
          }
        } else {
          // Teclado cerrado, restaurar altura y posición del micrófono
          messagesContainer.style.height = '';
          messagesContainer.style.maxHeight = '';
          
          if (microphoneDiv) {
            microphoneDiv.style.bottom = '';
          }
        }
      }
    };

    // Escuchar cambios en el viewport (cuando se abre/cierra el teclado)
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', adjustMessagesHeight);
    } else {
      // Fallback: escuchar resize del window
      window.addEventListener('resize', adjustMessagesHeight);
    }

    // También escuchar cuando el input recibe/pierde foco
    const handleInputFocus = () => {
      setTimeout(adjustMessagesHeight, 300);
    };

    const handleInputBlur = () => {
      setTimeout(adjustMessagesHeight, 300);
    };

    // Observar cuando se agrega el input al DOM
    const observer = new MutationObserver(() => {
      const input = document.querySelector('.rcw-input');
      if (input && !input.hasAttribute('data-keyboard-listener')) {
        input.setAttribute('data-keyboard-listener', 'true');
        input.addEventListener('focus', handleInputFocus);
        input.addEventListener('blur', handleInputBlur);
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    // Verificar si el input ya existe
    const input = document.querySelector('.rcw-input');
    if (input) {
      input.addEventListener('focus', handleInputFocus);
      input.addEventListener('blur', handleInputBlur);
    }

    return () => {
      if (window.visualViewport) {
        window.visualViewport.removeEventListener('resize', adjustMessagesHeight);
      } else {
        window.removeEventListener('resize', adjustMessagesHeight);
      }
      observer.disconnect();
      const input = document.querySelector('.rcw-input');
      if (input) {
        input.removeEventListener('focus', handleInputFocus);
        input.removeEventListener('blur', handleInputBlur);
      }
    };
  }, []);
  */
 
  useEffect(() => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('/Service-worker.js')
        .catch((error) => console.error('Error al registrar el Service Worker:', error));
    }

    const fetchData = async () => {
      try {
        document.querySelector('.body-div').style.paddingTop = '0';
        const cache = await caches.open('fitosanitarios-cache-v1.1');
        const cachedResponse = await cache.match('fitosanitarios.csv');
        
        if (cachedResponse && !isRefreshing) {
          const csv = await cachedResponse.text();
          const parsedData = Papa.parse(csv, { header: true }).data;
          setData(parsedData);
          updateOptions(parsedData, nombre, null, null, formulado, link, numRegistro, titular);
        } else {
          const response = await fetch('https://fitos.es/fitos.csv', { cache: 'no-store' });
          const reader = response.body.getReader();
          let decoder = new TextDecoder('utf-8');
          let csv = '';
          let done = false;

          while (!done) {
            const { value, done: doneReading } = await reader.read();
            done = doneReading;
            csv += decoder.decode(value, { stream: true });
          }

          const parsedData = Papa.parse(csv, { header: true }).data;
          setData(parsedData);
          updateOptions(parsedData, nombre, null, null, formulado, link, numRegistro, titular);

          setLoading(false);
          setIsRefreshing(false);

          await cache.put('fitosanitarios.csv', new Response(csv));
        }
      } catch (error) {
        console.error('Error al cargar los datos:', error);
      } finally {
        setLoading(false);
        setIsRefreshing(false);
        // Restablecer el padding-top a su valor original
        document.querySelector('.body-div').style.paddingTop = '';
      }
    };

    fetchData();
  }, [isRefreshing]); // Se ejecuta cuando cambia isRefreshing o al montar

  // useEffect separado para tracking (solo una vez al montar)
  useEffect(() => {
    inicializarTracking();
  }, []); // Array vacío = solo al montar el componente 

  const toggleListening = () => {
    if (listening) {
      recognitionRef.current.stop();
      handleAnimationEnd();
    } else {
      recognitionRef.current.start();
      setListening(true);
    }
  };

  const handleClickMicro = () => {
    // Lanzamos la animación
    setAnimate(true);
    // Y disparamos tu lógica de start/stop
    toggleListening();
  };

  const handleAnimationEnd = () => {
    // Limpiamos para poder volver a animar en el siguiente click
    setAnimate(false);
  };

  async function parseExcelToJson(blob) {
    const arrayBuffer = await blob.arrayBuffer();
    const workbook     = XLSX.read(arrayBuffer, { type: 'array' });
    const sheetName    = workbook.SheetNames[0];
    const worksheet    = workbook.Sheets[sheetName];
  
    // Obtén un array de arrays (cada fila es un array)
    const raw = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
    const headers = raw[0] || [];
    const rows = raw.slice(1).map(row => {
      const obj = {};
      headers.forEach((h, i) => (obj[h] = row[i]));
      return obj;
    });
  
    return { headers, rows };
  }

  const checkConnection = async () => {
    try {
      await fetch('https://www.google.com?no-sw=true', { mode: 'no-cors' });
    } catch (error) {
      toast.current.show({ severity: 'error', summary: 'Error', detail: 'No tienes conexión a Internet', life: 3000 });
    }
  };

  // Llama a checkConnection al inicio del componente
  useEffect(() => {
    checkConnection();
  }, []);

  const updateOptions = (data, nombre, cultivo, plaga, formulado, link, numRegistro, titular, autoComplete=false) => {
    const nombresSet = new Set();
    const formuladosSet = new Set();
    const linksSet = new Set();
    const numRegistrosSet = new Set();
    const titularesSet = new Set();
    data.forEach(item => {
      let nombreCoincide = ""
      let formuladoCoincide = ""
      let numRegistroCoincide = ""
      let titularCoincide = ""

      if(autoComplete){
        nombreCoincide = !nombre || (nombre && item.Nombre_Comercial && item.Nombre_Comercial.trim().toLowerCase() === nombre.trim().toLowerCase());
        formuladoCoincide = !formulado || (formulado && item.Formulado && item.Formulado.trim().toLowerCase() === formulado.trim().toLowerCase());
        numRegistroCoincide = !numRegistro || (numRegistro && item.Num_Registro && item.Num_Registro.trim().toLowerCase() === numRegistro.trim().toLowerCase());
        titularCoincide = !titular || (titular && item.Titular && item.Titular.trim().toLowerCase() === titular.trim().toLowerCase());
      }else{
        nombreCoincide = !nombre || (nombre && item.Nombre_Comercial && item.Nombre_Comercial.trim().toLowerCase().includes(nombre.trim().toLowerCase()));
        formuladoCoincide = !formulado || (formulado && item.Formulado && item.Formulado.trim().toLowerCase().includes(formulado.trim().toLowerCase()));
        numRegistroCoincide = !numRegistro || (numRegistro && item.Num_Registro && item.Num_Registro.trim().toLowerCase().includes(numRegistro.trim().toLowerCase()));
        titularCoincide = !titular || (titular && item.Titular && item.Titular.trim().toLowerCase().includes(titular.trim().toLowerCase()));
      }
      if (nombreCoincide && formuladoCoincide && numRegistroCoincide && titularCoincide) {
        if (item.Nombre_Comercial) nombresSet.add(item.Nombre_Comercial.trim());
        if (item.Formulado) formuladosSet.add(item.Formulado.trim());
        if (item.Link) linksSet.add(item.Link.trim());
        if (item.Num_Registro) numRegistrosSet.add(item.Num_Registro.trim());
        if (item.Titular) titularesSet.add(item.Titular.trim());
      }
    });

    setNombres(Array.from(nombresSet).sort((a, b) => a.localeCompare(b)));
    setFormulados(Array.from(formuladosSet).sort((a, b) => a.localeCompare(b)));
    setLinks(Array.from(linksSet).sort((a, b) => a.localeCompare(b)));
    setNumRegistros(Array.from(numRegistrosSet).sort((a, b) => a.localeCompare(b)));
    setTitulares(Array.from(titularesSet).sort((a, b) => a.localeCompare(b)));
    
    if (autoComplete) {
      if (Array.from(nombresSet).length === 1) {
        setNombre(Array.from(nombresSet)[0]);
      }
      if (Array.from(formuladosSet).length === 1) {
        setFormulado(Array.from(formuladosSet)[0]);
      }
      if (Array.from(numRegistrosSet).length === 1) {
        setNumRegistro(Array.from(numRegistrosSet)[0]);
      }
      if (Array.from(titularesSet).length === 1) {
        setTitular(Array.from(titularesSet)[0]);
      }
    }
  };

  const searchNombre = (event) => {
    const query = event.query.toLowerCase();
    setFilteredNombres(nombres.filter((nombre) => nombre.toLowerCase().includes(query)));
  };

  const searchFormulado = (event) => {
    const query = event.query.toLowerCase();
    setFilteredFormulados(formulados.filter((formulado) => formulado.toLowerCase().includes(query)));
  };

  const searchNumRegistro = (event) => {
    const query = (event.query || "").toLowerCase();
    setFilteredNumRegistros(numRegistros.filter((numRegistro) => numRegistro.toLowerCase().includes(query)));
  };

  const handleOnFocus = (autoComplete, isNumRegistro=false, isNombre=false, isFormulado=false, isTitular=false) => {
    // Invocamos la función de búsqueda con query vacío para cargar todas las sugerencias
    if(isNumRegistro){
      searchNumRegistro({ query: '' });
    }
    if(isNombre){
      searchNombre({ query: '' });
    }
    if(isFormulado){
      searchFormulado({ query: '' });
    }
    if(isTitular){
      searchTitular({ query: '' });
    }

    // Si la referencia está asignada y contiene el método show, lo llamamos para mostrar el panel
    if (autoComplete.current && autoComplete.current.show) {
      autoComplete.current.show();
    }
  };

  const searchTitular = (event) => {
    const query = event.query.toLowerCase();
    setFilteredTitulares(titulares.filter((titular) => titular.toLowerCase().includes(query)));
  };

  const handleNombreSelect = (e) => {
    setNombre(e.value);
    updateOptions(data, e.value, null, null, formulado, link, numRegistro, titular, true);
  };

  const handleFormuladoSelect = (e) => {
    setFormulado(e.value);
    updateOptions(data, nombre, null, null, e.value, link, numRegistro, titular, true);
  };

  const handleNumRegistroSelect = (e) => {
    setNumRegistro(e.value);
    updateOptions(data, nombre, null, null, formulado, link, e.value, titular, true);
  };

  const handleTitularSelect = (e) => {
    setTitular(e.value);
    updateOptions(data, nombre, null, null, formulado, link, numRegistro, e.value, true);
  };

  const handlePdfButtonClick = async () => {
    if (links.length !== 1) {
      return;
    }
    
    // Registrar click en botón PDF
    registrarClick('boton-ver-pdf', 'formulario', {
      num_registro: numRegistro,
      nombre: nombre
    });
    
    try {
      const response = await fetch(`https://fitos.es/pdfs/${numRegistro}.pdf`);
      if (response.ok) { // Cambiado de response.status === 200 a response.ok
        navigate(`/pdf/${numRegistro}`, { state: { nombre, formulado, numRegistro, titular, messageCount } });
      } else {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'No tienes conexión a Internet', life: 3000 });
      }
    } catch (error) {
      console.error('Error al realizar la solicitud de red:', error); // Añadido para más detalles
      toast.current.show({ severity: 'error', summary: 'Error', detail: 'No tienes conexión a Internet', life: 3000 });
    }
  };

  const handleClearButtonClick = () => {
    setNombre('');
    setFormulado('');
    setNumRegistro('');
    setTitular('');
    navigate(`/`, { state: {} });
    updateOptions(data, '', null, null, '', link, '', '');
  };

  const handleRefreshButtonClick = () => {
    setIsRefreshing(true);
    setLoading(true);
    checkConnection(); // Llama a checkConnection aquí
  };

  const openUrlAutomatically = (text) => {
    const urlPattern = /(https?:\/\/[^\s]+)/g;
    const match = urlPattern.exec(text);
    if (match) {
      window.open(match[0], '_blank');
    }
  }

  useEffect(() => {
    if(messageCount === 0){
      addResponseMessage('¡Bienvenido!, hazme la pregunta que necesites sobre cualquier producto fitosanitario.');
      setMessageCount(1);
    }
  }, []);

  const handleNewUserMessage = async (question) => {
    // Registrar pregunta del chat con todos los detalles
    registrarPreguntaChat(question, conversationId);
    
    try {
      // Añadir un div de loading a la clase rcw-messages-container
      const messagesContainer = document.querySelector('.rcw-messages-container');
      let loadingDiv;
      if (messagesContainer) {
        loadingDiv = document.createElement('div');
        loadingDiv.className = 'loading-container';
        
        const loadingChatDiv = document.createElement('div');
        loadingChatDiv.className = 'loading-chat';
        
        loadingDiv.appendChild(loadingChatDiv);
        messagesContainer.appendChild(loadingDiv);
      }
      // Cerrar el teclado
      const inputElement = document.querySelector('.rcw-send');
      if (inputElement) {
        inputElement.focus();
        inputElement.blur();
      }
      // Con Conversations API solo enviamos question y conversation_id (si existe)
      const payload = {
        question: question,
        ...(conversationId ? { conversation_id: conversationId } : {}),
      };

      const response = await fetch('https://fitos.es/api/ask', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-api-fitos': X_API_FITOS_KEY
        },
        body: JSON.stringify(payload),
        cache: 'no-store'
      });

      if (!response.ok) {
        throw new Error('Error en la respuesta de la API');
      } else if (loadingDiv) {
        messagesContainer.removeChild(loadingDiv);
      }

      // ⚠️ LEER HEADERS ANTES DEL STREAMING para que estén disponibles en la próxima petición
      const nextConversationId = response.headers.get('X-Conversation-Id');
      if (nextConversationId) {
        setConversationId(nextConversationId);
        console.log('Conversation ID guardado:', nextConversationId);
      }

      const reader = response.body.getReader();
      const decoder = new TextDecoder('utf-8');
      let botResponse = '';
      let completeResponse = '';
      let scrollCount = 0;

      // Añadir un mensaje inicial vacío
      addResponseMessage('');

      // Esperar un breve momento para asegurarse de que el mensaje se ha añadido
      setTimeout(() => {
        // Obtener el último mensaje añadido después de añadir el mensaje vacío
        const messages = document.querySelectorAll('.rcw-message-text');
        const lastMessageElement = messages[messages.length - 1];

        // Leer el stream de datos
        (async () => {
          while (true) {
            const { done, value } = await reader.read();
            if (done) break;
            const chunk = decoder.decode(value, { stream: true });
            completeResponse += chunk;

            // Buscar el marcador de inicio del historial
            const historyMarkerIndex = completeResponse.indexOf("\nhistorial: ");
            if (historyMarkerIndex !== -1) {
              // Separar la respuesta del historial
              botResponse = completeResponse.substring(0, historyMarkerIndex).trim();
              const historyJson = completeResponse.substring(historyMarkerIndex + 12).trim();

              // Abrir las URLs encontradas en la respuesta, de momento no se hace para eso esta la pantalla previa
              // openUrlAutomatically();

              // Actualizar el historial
              setChatHistory(JSON.parse(historyJson));
              // Salir del bucle ya que hemos procesado todo
              break;
            }

            // Transformar texto en negrita y encabezados de nivel 3
            const formattedResponse = completeResponse
                .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
                .replace(/### (.*?)\n/g, '<h3>$1</h3>\n')
                .replace(/"([^"]+)"/g, '<strong>$1</strong>')
                .replace(/#### (.*?)\n/g, '<h4>$1</h4>\n')
                .replace(/\[Descargar.*?\]\(sandbox:\/mnt\/data\/([^\/\)]+)\)/g, '<a href="#" style="color: blue; text-decoration: underline;" onclick="downloadFile(\'$1\')">$1</a>')
                .replace(/\/mnt\/data\/([^\/\s\)]+)/g, '<a href="#" style="color: blue; text-decoration: underline;" onclick="downloadFile(\'$1\')">$1</a>')
                // Detectar archivos Excel generados (cualquier nombre .xlsx)
                .replace(/`([^`]+\.xlsx)`/g, '<a href="#" style="color: blue; text-decoration: underline;" onclick="downloadFile(\'$1\')">$1</a>')
                .replace(/(?<!["\w/.])([a-zA-Z0-9_-]+\.xlsx)(?!["\w])/g, '<a href="#" style="color: blue; text-decoration: underline;" onclick="downloadFile(\'$1\')">$1</a>')
                .replace(/\n/g, '<br>');

            // Actualizar el contenido del último mensaje
            if (lastMessageElement) {
              lastMessageElement.innerHTML = formattedResponse;
              // Desplazar hacia abajo cada vez que se actualiza el mensaje, hasta un máximo de 100 veces
              if (scrollCount < 100) {
                  const messagesContainer = document.querySelector('.rcw-messages-container');
                  if (messagesContainer) {
                      messagesContainer.scrollTop = messagesContainer.scrollHeight;
                      scrollCount++; // Incrementar el contador
                  }
              }
            }
          }
          showTable()
        })();
      }, 100); // Ajusta el tiempo de espera según sea necesario
        
      openUrlAutomatically(botResponse);
    } catch (error) {
      console.error('Error al obtener respuesta de ChatGPT:', error);
    }
  };

  useEffect(() => {
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!SpeechRecognition) {
      toast.current.show({
        severity: 'warn',
        summary: 'Voice not supported',
        detail: 'Tu navegador no soporta reconocimiento de voz',
        life: 3000
      });
      return;
    }
    const recognition = new SpeechRecognition();
    recognition.lang = 'es-ES';
    recognition.interimResults = false;
    recognition.maxAlternatives = 1;

    recognition.onresult = (event) => {
      const transcript = event.results[0][0].transcript;
      addUserMessage(transcript);
      handleNewUserMessage(transcript);
    };
    recognition.onend = () => {
      setListening(false);
      handleAnimationEnd();
    };
    recognitionRef.current = recognition;

    // Cleanup: detenemos la instancia anterior antes de crear otra
    return () => {
      recognition.stop();
    };
  }, []);


  // 1) Definimos la función dentro del componente para que pueda
  //    usar `toast.current` y demás refs de React.
  const downloadFile = useCallback(async (filename) => {
    // Registrar descarga
    registrarDescarga(filename, filename.endsWith('.xlsx') ? 'excel' : 'pdf');
    
    try {
      const response = await fetch('https://fitos.es/api/get_file', {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'x-api-fitos': X_API_FITOS_KEY
        },
        body: JSON.stringify({
          filename
        })
      });
      if (!response.ok) {
        throw new Error('Error al descargar el archivo');
      }
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error('Error al descargar el archivo', error);
      toast.current.show({
        severity: 'error',
        summary: 'Descarga fallida',
        detail: 'No se pudo descargar el archivo',
        life: 3000
      });
    }
  }, [toast]);

  const showTable = useCallback(async () => {
    try {
      const messages = document.querySelectorAll('.rcw-message-text');
      const lastMessage = messages[messages.length - 1];
      const html = lastMessage.innerHTML;
      const downloadLinkMatch = html.match(/onclick="downloadFile\('([^']+)'\)"/);
      if (downloadLinkMatch) {
        const filename = downloadLinkMatch[1];
        const response = await fetch('https://fitos.es/api/get_file', {
          method: 'POST',
          headers: { 
            'Content-Type': 'application/json',
            'x-api-fitos': X_API_FITOS_KEY
          },
          body: JSON.stringify({
            filename
          })
        });
        if (!response.ok) {
          throw new Error('Error al descargar el archivo');
        }
        const blob = await response.blob();
        // Parsear a JSON
        const { headers, rows } = await parseExcelToJson(blob);
      
        // Renderizar DataTable
        renderCustomComponent(
          () => (
            <div style={{ overflowX: 'auto', maxWidth: '100%', marginTop: '0.5rem', borderRadius: '10px', backgroundColor: '#3d0090' }}>
              <DataTable
                value={rows}
                paginator
                rows={10}
                stripedRows
                style={{ background: 'white', borderRadius: '6px' }}
              >
                {headers.map((field) => (
                  <Column
                    key={field}
                    field={field}
                    header={field}
                    sortable
                    filter
                    headerStyle={{ backgroundColor: '#3d0090', color: '#fff' }}
                  />
                ))}
              </DataTable>
            </div>
          ),
          { align: 'left' }
        );
      }
    } catch (error) {
      console.error('Error al descargar el archivo', error);
      toast.current.show({
        severity: 'error',
        summary: 'Descarga fallida',
        detail: 'No se pudo descargar el archivo',
        life: 3000
      });
    }
  }, [toast]);

  // 2) Exponemos la función en el ámbito global para que 
  //    los onclick inline la puedan invocar.
  useEffect(() => {
    window.downloadFile = downloadFile;
  }, [downloadFile]);

  return (
      <>{/* <ModalInstall /> */}<div className="body-div flex flex-column align-items-center">
      <Toast ref={toast} />
      <div className="header-div flex align-items-center justify-content-center w-full pt-2 pb-2 border-bottom-2 border-black-alpha-90">
        <img src={logo_nematool} alt="Logo" className="mr-1" style={{ width: '150px', height: 'auto' }} />
        <h1 className='ml-1'>Fitos.es</h1>
      </div>
      <div className="form-div flex flex-column align-items-center w-11">
        {loading ? (
          <div className="loading"></div>
        ) : (
          <div className='w-full'>
            <form className="flex flex-column align-items-center mt-5 mb-5 w-full">
              <div className="flex flex-column w-full">
                <label htmlFor="numRegistro" className="text-xl font-semibold">Número de Registro:</label>
                <AutoComplete
                  ref={autoCompleteNumRegistroRef}
                  className='mt-2 mb-3 w-full'
                  id="numRegistro"
                  value={numRegistro}
                  suggestions={filteredNumRegistros}
                  completeMethod={searchNumRegistro}
                  minLength={0}
                  onChange={(e) => setNumRegistro(e.value)}
                  onFocus={() => handleOnFocus(autoCompleteNumRegistroRef, true, false, false, false)}
                  onSelect={handleNumRegistroSelect}
                  inputClassName="w-full" />
              </div>
              <div className="flex flex-column w-full">
                <label htmlFor="nombre" className="text-xl font-semibold">Nombre Comercial:</label>
                <AutoComplete
                  ref={autoCompleteNombreRef}
                  className='mt-2 mb-3 w-full'
                  id="nombre"
                  value={nombre}
                  suggestions={filteredNombres}
                  completeMethod={searchNombre}
                  onChange={(e) => setNombre(e.value)}
                  onFocus={() => handleOnFocus(autoCompleteNombreRef, false, true, false, false)}
                  onSelect={handleNombreSelect}
                  inputClassName="w-full" />
              </div>
              <div className="flex flex-column w-full">
                <label htmlFor="formulado" className="text-xl font-semibold">Composición:</label>
                <AutoComplete
                  ref={autoCompleteFormuladoRef}
                  className='mt-2 mb-3 w-full'
                  id="formulado"
                  value={formulado}
                  suggestions={filteredFormulados}
                  completeMethod={searchFormulado}
                  onChange={(e) => setFormulado(e.value)}
                  onFocus={() => handleOnFocus(autoCompleteFormuladoRef, false, false, true, false)}
                  onSelect={handleFormuladoSelect}
                  inputClassName="w-full" />
              </div>
              <div className="flex flex-column w-full">
                <label htmlFor="titular" className="text-xl font-semibold">Titular:</label>
                <AutoComplete
                  ref={autoCompleteTitularRef}
                  className='mt-2 w-full'
                  id="titular"
                  value={titular}
                  suggestions={filteredTitulares}
                  completeMethod={searchTitular}
                  onChange={(e) => setTitular(e.value)}
                  onFocus={() => handleOnFocus(autoCompleteTitularRef, false, false, false, true)}
                  onSelect={handleTitularSelect}
                  inputClassName="w-full" />
              </div>
            </form>
            <div className='button-div flex justify-content-around mb-5'>
              <Button
                label="Ver PDF"
                onClick={handlePdfButtonClick}
                className={`p-button ${links.length > 1 ? 'p-disabled' : ''}`} />
              <Button
                label="Limpiar"
                onClick={handleClearButtonClick}
                className="p-button" />
              <Button
                icon="pi pi-refresh"
                onClick={handleRefreshButtonClick}
                className="p-button-icon-only" />
            </div>
          </div>
        )}
      </div>
      <div className='div-microphone' style={{ position: 'absolute', zIndex: 999999, display: widgetIsOpen ? 'block' : 'none' }}>
        <i
            className={`
              pi pi-microphone
              ${listening ? 'listening' : ''}
              ${animate   ? 'pulse'     : ''}
            `}
            style={{
              fontSize: '1.5rem',
              cursor: 'pointer',
              color: listening ? 'red' : '#48A6FF'
            }}
            onClick={handleClickMicro}
          />
        </div>
      <Widget
        handleNewUserMessage={handleNewUserMessage}
        handleToggle={(isOpen) => setWidgetIsOpen(isOpen)}
        subtitle={null}
        emojis={true}
        title={"Chat"}
        showTimeStamp={false}
        senderPlaceHolder={"Escribe tu mensaje..."}
        style={{ maxWidth: '100%', margin: '0 auto' }} />
    </div>
    <div style={{
        position: "fixed",
        bottom: "35px",
        left: "10px",
        fontSize: "0.9rem",
        color: "black",
        backgroundColor: "rgba(255,255,255,0.8)",
        padding: "4px 8px",
        borderRadius: "4px"
      }}>
      Versión v1.1
    </div>
    </>
  );
};

export default Main;
